export const copilotDropdownFeatureFlags = [
  'email-translation',
  'agent-copilot-auto-translate',
  'agent-copilot-pin-actions',
  'mim-drafts',
] as const;
